module.exports = __webpack_public_path__ + "static/media/04.335653d6.png";